import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styles from './styles.scss';
import Loader from 'react-loader-spinner';
import { MODAL_TYPES } from 'actions/modals';
import classnames from 'classnames';

class Spinner extends PureComponent {
  modalLoaderExists = () => {
    return this.props.modals.some(modal => {
      return modal.props.modalType === MODAL_TYPES.custom;
    });
  };

  render() {
    const { loader } = this.props;

    let loading = false;
    if (this.props.type === 'modal' && loader.loading) {
      loading = true;
    } else if (
      loader.loading - loader.customLoading > 0 &&
      !this.modalLoaderExists()
    ) {
      loading = true;
    }

    return (
      <div>
        <div className={classnames(styles.loader, { [styles.in]: loading })}>
          <Loader type="TailSpin" color="#1899D8" height={40} width={40} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { loader: state.loader, modals: state.modals.all };
}

export default connect(mapStateToProps)(Spinner);



// WEBPACK FOOTER //
// ./src/components/loader/index.js